import Image, { ImageProps } from "next/image";
import Link from "next/link";

export default function Logo({ text, ...props }: Omit<ImageProps, 'src'> & { text?: boolean }) {
  return <Link href="/" passHref><a><img src={`/images/logo${text ? '-text' : ''}.png`} {...props} /></a></Link>
}
